<template>
  <Select
    v-model="dictinary_code"
    :placeholder="$t('user.' + dictionaryCategory)"
    :style="{ width: width + (typeof width == 'number' ? 'px' : '') }"
    :size="size"
    :multiple="
      ['TAG1', 'TAG2', 'TAG3', 'TAG4', 'TAG5'].includes(dictionaryCategory)
    "
    transfer
    ref="select"
    :max-tag-count="2"
    clearable
    @on-change="handleChange"
    @on-open-change="handlerOpen"
  >
    <Option v-for="(item, key) in dictionary_list" :key="key" :value="item">{{
      item
    }}</Option>
  </Select>
</template>
<script>
import { load_dictionary } from "@/api/user";
import { mapActions } from "vuex";
import {
  load_approval_dictionary_by_event,
  load_event_dictionary_by_event,
  query_tags
} from "@/api/tag";
const types = {
  COMPANY: "user_company_list",
  TAG1: "add_tag1_list",
  TAG2: "add_tag2_list",
  TAG3: "add_tag3_list"
};
const customTagDataTypes = ["approval", "attendee"];
export default {
  name: "dictionaryList",
  props: {
    isClear: {
      type: Boolean,
      default: false
    },
    width: {
      type: [Number, String],
      default: "auto"
    },
    dictionaryCode: {
      type: [String, Array]
    },
    dictionaryCategory: {
      type: String,
      default: "LOCATION"
    },
    size: {
      type: String,
      default: "small"
    },
    isCustomTagData: {
      type: Boolean,
      default: false
    },
    customTagDataType: {
      type: String,
      default: ""
    }
  },
  watch: {
    dictionaryCode(newVal, oldVal) {
      this.dictinary_code = newVal;
    },
    isClear() {
      this.$refs.select.clearSingleSelect();
    }
  },
  data() {
    return {
      dictionary_list: [],
      dictinary_code: "",
      isOpen: true,
      queryTags: ["TAG1", "TAG2", "TAG3"]
    };
  },
  created() {
    let self = this;
    if (this.queryTags.includes(this.dictionaryCategory)) {
      this.get_user_list_tags(this.dictionaryCategory)
    } else {
      load_dictionary({
        category: self.dictionaryCategory
      }).then(res => {
        self.dictionary_list = res.body;
        // console.log(types[this.dictionaryCategory]);
        if (types[this.dictionaryCategory]) {
          this.saveFormData({
            data: res.body,
            type: types[this.dictionaryCategory]
          });
        }
      });
    }

    this.dictinary_code = this.dictionaryCode;
  },
  methods: {
    ...mapActions("formData", ["saveFormData"]),
    // 获取用户列表tag1-tag3的数据
    async get_user_list_tags(tag="") {
      const res = await query_tags({
        tag_kewords: "",
        category: tag.toLocaleLowerCase(),
        page_size: 1000,
        page_index: 1,
        sort: true
      });
      // console.log(res, 'resresresresresresresresres');
      this.dictionary_list = res.body.map(item => item.tag_value)
    },
    // 获取审批表tag
    async load_approval_dictionary_by_event() {
      const res = await load_approval_dictionary_by_event({
        category: this.dictionaryCategory.toLocaleLowerCase(),
        evt_id: this.$route.params.event_id
      });
      this.dictionary_list = res.body;
      this.isOpen = false;
    },
    //获取参会人的tag
    async load_event_dictionary_by_event() {
      const res = await load_event_dictionary_by_event({
        category: this.dictionaryCategory.toLocaleLowerCase(),
        evt_id: this.$route.params.event_id
      });
      // console.log(res, "我是参会人的tag");

      this.dictionary_list = res.body;
      this.isOpen = false;
    },
    handleChange() {
      if (this.isClear === true) {
        this.$emit("update:isClear", false);
      }
      this.$emit("updateDictionaryCode", this.dictinary_code);
    },
    // 下拉框展开时触发
    handlerOpen(flag) {
      if (
        flag === true &&
        this.isOpen &&
        ["TAG1", "TAG2", "TAG3", "TAG4", "TAG5"].includes(
          this.dictionaryCategory
        )
      ) {
        // console.log(customTagDataTypes.includes(this.$parent.customTagDataType));
        if (
          this.isCustomTagData &&
          customTagDataTypes.includes(this.customTagDataType)
        ) {
          if (this.customTagDataType === "approval") {
            this.load_approval_dictionary_by_event();
          }
          if (this.customTagDataType === "attendee") {
            this.load_event_dictionary_by_event();
          }
        }
      }
    }
  }
};
</script>

<style lang="less" scoped>
/deep/ .ivu-select-dropdown {
  max-width: 208px;
  overflow: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/dictionary_list.vue